'use strict';

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

require('babel-polyfill');

require('../static/node_modules/bootstrap.css');

var _reactRouter = require('react-router');

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _errorBoundary = require('@liveauctioneers/caterwaul-components/lib/errorBoundary');

var _errorBoundary2 = _interopRequireDefault(_errorBoundary);

var _sentry = require('./utils/sentry');

var _initialData = require('./redux/initialData');

var _initialData2 = _interopRequireDefault(_initialData);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _isOnline = require('./utils/isOnline');

var _isOnline2 = _interopRequireDefault(_isOnline);

var _boomerang = require('./utils/boomerang.js');

var _config = require('./redux/modules/config');

var _script = require('./utils/script');

var _reduxPersist = require('redux-persist');

var _Provider = require('./components/IntlRedux/Provider');

var _Provider2 = _interopRequireDefault(_Provider);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxAsyncConnect = require('@liveauctioneers/redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _reactRouterScroll = require('react-router-scroll');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-imports */
/* eslint-disable import/newline-after-import */
require('./theme/fonts.scss');
require('./theme/theme.css');
require('@liveauctioneers/react-photoswipe/assets/photoswipe.css');
require('@liveauctioneers/react-photoswipe/assets/photoswipe-light.css');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');
require('../static/deskPopup.css');
require('react-datepicker/dist/react-datepicker.css');

// import { whyDidYouUpdate } from 'why-did-you-update';
// whyDidYouUpdate(React, { exclude: [/^Overlay/], groupByComponent: true });

// /* Soasta Boomerang config */
var hadRouteChange = false;
function onEnter() {
    hadRouteChange = true;
}

function localStorageCheck() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

/* end Soasta config code 2 */

function renderTheApp() {
    var dest = document.getElementById('content');
    var localStoragePersistConfig = {
        debounce: 33,
        keyPrefix: 'la:',
        whitelist: ['persist']
    };

    /* eslint-disable no-unused-vars */
    _promise2.default.all([window.__data ? true : (0, _isOnline2.default)()]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
            online = _ref2[0];

        var data = window.__data ? (0, _extends3.default)({}, window.__data) : (0, _initialData2.default)();
        var store = (0, _create2.default)(_reactRouter.browserHistory, data);

        if (!localStorageCheck()) {
            return _reactDom2.default.render((0, _jsx3.default)('span', {
                style: {
                    backgroundColor: '#ffebe8',
                    border: '1px solid #dd3c10',
                    display: 'block',
                    margin: '100px auto',
                    padding: '10px 20px 20px',
                    textAlign: 'center',
                    width: '340px'
                }
            }, void 0, (0, _jsx3.default)('h2', {
                style: { marginBottom: '20px' }
            }, void 0, 'Cookies Required'), (0, _jsx3.default)('p', {
                style: { display: 'inline-block', maxWidth: '300px' }
            }, void 0, 'Cookies are not enabled on your browser. Please enable cookies in your browser preferences to continue.')), dest);
        }

        (0, _boomerang.initBoomerang)(store).then(function (_ref3) {
            var plugins = _ref3.plugins;

            if (plugins && plugins.History) {
                plugins.History.hook(_reactRouter.browserHistory, hadRouteChange);
            }
        });

        var _store$getState = store.getState(),
            _store$getState$confi = _store$getState.config,
            buildNumber = _store$getState$confi.buildNumber,
            deployment = _store$getState$confi.deployment;

        (0, _sentry.installSentry)({ environment: deployment, release: buildNumber });

        // save to local storage
        (0, _reduxPersist.persistStore)(store, localStoragePersistConfig);
        var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, { adjustUrlOnReplay: false });
        var routes = (0, _routes2.default)(store.getState().whiteLabel.isWhiteLabel);

        (0, _script.loadStripe)((0, _config.getStripePublishKey)(store.getState()));

        (0, _reactRouter.match)({ history: history, routes: routes }, function (error, redirectLocation, renderProps) {
            _reactDom2.default.hydrate((0, _jsx3.default)(_errorBoundary2.default, {
                onError: _sentry.captureError
            }, void 0, (0, _jsx3.default)(_Provider2.default, {
                store: store
            }, 'provider', _react2.default.createElement(_reactRouter.Router, (0, _extends3.default)({}, renderProps, {
                history: history,
                onEnter: onEnter,
                render: function render(props) {
                    return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
                        filter: function filter(item) {
                            return !item.deferred;
                        },
                        render: (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll.useScroll)())
                    }));
                }
            })))), dest);
        });

        if (process.env.NODE_ENV !== 'production') {
            window.React = _react2.default; // enable debugger
        }
    });
}

if (!global.Intl) {
    require.ensure(['intl', 'intl/locale-data/jsonp/en.js'], function (require) {
        require('intl');
        require('intl/locale-data/jsonp/en.js');
        renderTheApp();
    }, 'ConditionalIntlPolyfill');
} else {
    renderTheApp();
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 2Eh+
// module chunks = 60